"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modsClassName = void 0;

var classnames_1 = __importDefault(require("classnames"));

function modsClassName(props) {
  var modKeys = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    modKeys[_i - 1] = arguments[_i];
  }

  var classes = props.classes;
  return classnames_1.default.apply(void 0, modKeys.map(function (key) {
    var _a;

    return _a = {}, _a[classes[key]] = props[key], _a;
  }));
}

exports.modsClassName = modsClassName;